import { render, staticRenderFns } from "./StaffQuestion.vue?vue&type=template&id=2cf3168c&"
import script from "./StaffQuestion.vue?vue&type=script&lang=js&"
export * from "./StaffQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports